var opt = require('./opt');
var util = require('./util');
var report = require('./report');

var startTime = new Date();

// 保存原先xla对象，用于noConflict的覆盖
var xlaBefore = window.xla

var _xla = {
    push: function (param) {
        if (param.type === 'pv' || param.type === 'pageview') {
            /**
             * @function pageview
             *
             * @description 用于发送某个指定URL的PV统计请求，通常用于AJAX页面的PV统计。
             * ```
             * xla.push({
             *   type: 'pageview',
             *   extdata: extdata,
             *   force: force
             * });
             * ```
             *
             * @param {object} [extdata] - 额外字段
             * @param {boolean} [force] - 是否强制上报
             *
             * @example
             * xla.push({
             *   type: 'pageview',
             *   extdata: { page: 'login' }
             * });
             */
            report({
                ii: param.type,
                ed: param.extdata || {},
                force: param.force
            });
        } else if (param.type === 'event') {
            /**
             * @function event
             *
             * @desc 用于触发某个事件，如某个按钮的点击，或播放器的播放/停止，以及游戏的开始/暂停等。
             * ```
             * xla.push({
             *   type: 'evet',
             *   category: category,
             *   action: action,
             *   extdata: extdata
             * });
             * ```
             *
             * @param {string} category - 要监控的目标的类型名称
             * @param {string} action - 用户跟网页进行交互的动作名称
             * @param {object} [extdata] - 事件的一些额外信息
             *
             * @example
             * xla.push({
             *   type: 'event',
             *   category: 'music',
             *   action: 'play',
             *   extdata: { title: 'Hey Jude' }
             * });
             */
            report({
                ii: param.type,
                cg: param.category,
                at: param.action,
                ed: param.extdata || {},
                force: param.force
            });
        } else if (param.type === 'tp') {
            report({
                ii:param.type,
                tp: param.tp,
                force: param.force
            });
        } else if (param.type === 'globalExtData') {
            /**
             * @function globalExtData
             *
             * @description 指定额外变量
             * ```
             * xla.push({
             *   type: 'globalExtData',
             *   data: data
             * })
             * ```
             *
             * @param {object} data - 额外字段
             *
             * @example
             * xla.push({
             *   type: 'globalExtData',
             *   data: { login: '1' }
             * });
             */
            opt.extend(param.data || {});
        } else if (param.type === 'config') {
            /**
             * @function config
             *
             * @desc SDK的初始化配置
             * ```javascript
             * xla.push({
             *   type: 'config',
             *   appid: appid,
             *   secret: secret,
             *   event: event,
             *   force: force
             * });
             * ```
             *
             * @param {string} appid - 应用的appid
             * @param {string} secret - 应用的secret
             * @param {array} [event=['click']] - 使用属性声明方式时的监听事件
             * @param {boolean} [force=true] - 是否实时上报
             *
             * @example
             * xla.push({
             *   type: 'config',
             *   appid: '100',
             *   secret: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
             *   event: ['click', 'mouseover']
             *   force: false
             * });
             */
            opt.config(param.appid, param.secret, param.event, param.force);
        }
    },

    // 版本号
    version: opt.v,

    // 回退上一个版本的xla对象，若上一个版本没有xla，则window.xia等于undefined
    // 返回当前版本的xla对象
    noConflict: function () {
        if (window.xla === _xla) {
            window.xla = xlaBefore;
        }

        return _xla;
    }
};

/**
 * @desc sdk加载前有上报
 */
if (window.xla instanceof Array) {
    for (var i = 0; i < window.xla.length; i++) {
        _xla.push(window.xla[i]);
    }
}

/**
 * @desc 对统计属性声明的DOM进行监听
 */
util.documentReady(function () {
    for (var i = 0; i < opt.event.length; i++) {
        util.delegate(document, opt.event[i], '[xla-on=' + opt.event[i] + ']', function () {
            _xla.push({
                type: 'event',
                category: this.getAttribute('xla-category'),
                action: this.getAttribute('xla-action'),
                extdata: eval('(' + this.getAttribute('xla-extdata') + ')')
            });
        });
    }
});

/**
 * @desc 页面卸载时上报页面访问时长
 * @desc 页面卸载时上报队列剩余数据
 */
util.on(window, 'unload', function () {
    _xla.push({
        type: 'tp',
        tp: new Date() - startTime,
        force: true
    });
});

/**
 * @desc 自动pv上报
 */
_xla.push({
    type: 'pv',
    extdata: eval('(' + document.body.getAttribute('xla-extdata') + ')')
});

window.xla = _xla;



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 0
// module chunks = 0